import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { getGeneralStorage, setGeneralStorage} from '../middleware/dataStorage';
import s from './onlineClass.module.css';
import RegistrableClassroomAnalysis from '../components/RegistrableClassroomAnalysis';

export default function OnlineClass() {
	const navigate = useNavigate();
	let params = useParams();
	
	const [toggleTag, setToggleTag] = useState((getGeneralStorage('onlineClassToggle') ?? "config"));
	
	const processToggleTag = (toggle) =>{
		setGeneralStorage('onlineClassToggle', toggle);
		setToggleTag(toggle)
	}
	
	useEffect(() => {
	}, []);
	
	return (<div style={{margin:"10px", padding:"10px"}}>
		<div className={s.optionToggleHolder}>
			<div className={s.optionToggle} style={(toggleTag=="registrableClassroomAnalysis")?{background:"#808080", color:"white"} : {cursor:"pointer"}} onClick={()=>processToggleTag("registrableClassroomAnalysis")}>Analysis</div>
		</div>
		
		<div>
			{
				(toggleTag=="registrableClassroomAnalysis") && (<RegistrableClassroomAnalysis />)
			}
		
		</div>
	</div>);
}